export const css = {
	root: '_1XrnjrYb',
	titleBlock: 'gB6oXmed',
	title: '_2Z-eFvs1',
	eyebrow: '_2-BcwAqe',
	openCloseIcon: '_1iAH4PCo',
	close: '_3q4Oz0nr',
	topicgroup: 'YIEi9pVt',
	item: '_32Lquqx2',
	setTitleBlock: '_3OJdFcFG',
	emptyTitleBlock: '_1axrlzxh',
	actionBlock: '_2cevP2fK',
	setTitle: 'zRZQMcEL',
	setProgress: '_2O5llon4',
	setProficiency: '_2LNZzOcg',
	accordionLegend: '_1gOrvr5g',
	accordionLegendPlaceholder: '_2CGJjf4y',
	accordionLegendProgress: '_3AmegXWK',
	accordionLegendProficiency: 'RKlGbfK0',
	accordionBody: '_2JvKHZcl',
	itemWrapper: '_2aoPcvzu',
	completed: 'NgtZA8Kh',
	shortDesc: '_3-a3sfD8',
	truncate: '_2Chk0CH3',
	status: '_2F2sGoWY',
	progressBar: '_1WF7j9bt',
	whiteIcon: 'NRKwYWTn',
	openTitle: 'H8h65lq8',
	closedTitle: '_3eO5Dlxi',
	lockIcon: '_3EFlf8VO',
	scorePill: 'vLotyb0b',
	scoreLabel: '_1ruBMJt7',
	statusLine: '_2WK6F5KT',
	' _key': 'book-widgets/topicaccordion'
};

export default css;
